export default __webpack_public_path__ + "static/media/Jump (5).c3c35ed1.png";